import { HStack, IconButton, Link } from "@chakra-ui/react";
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
import useSite from "../../../hooks/use-site";

const SocialMedia = () => {
  const {
    themeGeneralSettings: {
      siteSettings: { socialLinks },
    },
  } = useSite();

  const socialIcons = {
    fb: <FaFacebook />,
    instagram: <FaInstagram />,
    linkedin: <FaLinkedin />,
  };

  return (
    <HStack justifyContent={"center"} gap={4} py={4}>
      {socialLinks.map((link) => (
        <IconButton
          key={link.medium}
          as={Link}
          href={link.url}
          icon={socialIcons[link.medium]}
          border="none"
          _hover={{ bg: "transparent" }}
          size="lg"
          target="_blank"
          rel="noopener noreferrer"
          color="black"
        />
      ))}
    </HStack>
  );
};

export default SocialMedia;
